<template>
    <v-app>
        <v-container class="login-view" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4">
                    <v-card class="mx-auto text-center login-card" elevation="15">
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title class="headline">Enter Otisak Platform</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text class="pb-1">
                            <v-form ref="form" :disabled="disabled" lazy-validation>
                                <v-text-field
                                    class="pt-0"
                                    type="text"
                                    v-model="email"
                                    label="E-Mail"
                                    :rules="emailRules"
                                    prepend-icon="mdi-at" />
                                <v-text-field
                                    :type="showPassword ? 'text' : 'password'"
                                    v-model="password"
                                    label="Password"
                                    :rules="passwordRules"
                                    prepend-icon="mdi-lock"
                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    @click:append="showPassword = !showPassword" />
                            </v-form>
                        </v-card-text>
                        <v-card-actions class="px-4 pb-3">
                            <v-btn :disabled="disabled" block @click="validate" color="primary">
                                <span v-show="!disabled">Sign In</span>
                                <span v-show="disabled">
                                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                </span>
                            </v-btn>
                        </v-card-actions>
                        <p v-show="error" class="red--text text-body-2 pa-3">{{ error }}</p>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics';

export default {
    name: 'Login',
    data() {
        return {
            submitted: false,
            disabled: false,
            email: '',
            emailRules: [
                v => this.submitted ? !!v || 'E-mail is required' : true,
                v => this.submitted ? /.+@.+\..+/.test(v) || 'E-mail must be valid' : true
            ],
            showPassword: false,
            password: '',
            passwordRules: [
                v => this.submitted ? !!v || 'Password is required' : true
            ],
            error: ''
        }
    },
    methods: {
        validate() {
            this.submitted = true;
            if (this.$refs.form.validate()) {
                this.disabled = true;
                firebase
                    .auth()
                    .signInWithEmailAndPassword(this.email, this.password)
                    .then(() => {
                        this.$router.replace({ path: "/dashboard" });
                        this.$cookies.set('consent', {complied: true, ga_disabled: false}, '14d');
                        window[`ga-disable-${process.env.VUE_APP_FIREBASE_MEASUREMENT_ID}`] = false;
                        firebase.analytics().logEvent('login', {email: this.email});
                    })
                    .catch(err => {
                        this.error = err.message;
                    })
                    .finally(() => {
                        this.disabled = false;
                        this.submitted = false;
                    });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.login-view {
    background-image: url('../../public/images/backgounds/login.jpg');
    background-size: cover;
    height: 100vh;
    display: flex;
    align-items: center;

    .login-card {
        background-color: rgba(255, 255, 255, 0.72) !important;
        backdrop-filter: blur(4px);
    }
}
</style>
